module.exports = __webpack_public_path__ + "static/media/icon-money_ball-not_selected.5754b623.svg";